import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import { getLocalizedPath } from '@packages/shared/src/utils/getLocalizedPath/getLocalizedPath';
import { defineMessages, useIntl } from 'react-intl';
import { Link } from '@packages/modules/src/Link/Link';

export const messages = defineMessages({
  standardAgb: {
    id: 'BusinessTerms.LegalText',
    defaultMessage:
      'Es gelten die <conditions>Allgemeinen Geschäftsbedingungen</conditions> von Baur auch hinsichtlich des <revocation>Widerrufsrechts</revocation>.',
  },
  agbCheckbox: {
    id: 'BusinessTerms.AgbCheckbox',
    defaultMessage: `JA, ich stimme den <agb>AGB</agb> für bereits getätigte und künftige Bestellungen zu.\n
      Ich nehme die Bestimmungen zum <agb>Widerrufsrecht</agb> und die <dataProtection>Datenschutzhinweise</dataProtection> zur Kenntnis.`,
  },
  agbUnchecked: {
    id: 'BusinessTerms.AgbCheckbox.uncheckedError',
    defaultMessage:
      'Bitte stimmen Sie unseren AGB zu, indem Sie das entsprechende Kontrollkästchen markieren.',
  },
  weeeTakeBackMessage: {
    id: 'BusinessTerms.WEEETakeBackAddition',
    defaultMessage: 'Über die gesetzliche Möglichkeit zur Altgeräte-Rücknahme wurde informiert.',
  },
});

export const BusinessTerms: React.FC = () => {
  const {
    order: { externalUrls },
  } = useConfig();
  const { locale, formatMessage } = useIntl();

  return (
    <div className="border-color-grey text-color-text-darktransparent bg-color-grey-light border-t p-1 text-center">
      <div data-testid="business-terms-text" className="text-size-body-xs">
        {formatMessage(messages.standardAgb, {
          conditions: (chunks: React.ReactNode) => (
            <Link
              href={getLocalizedPath(externalUrls.agb, locale)}
              className="text-color-text-darktransparent cursor-pointer underline"
              openInNewTab
            >
              {chunks}
            </Link>
          ),
          revocation: (chunks: React.ReactNode) => (
            <Link
              href={getLocalizedPath(externalUrls.revocation, locale)}
              className="text-color-text-darktransparent cursor-pointer underline"
              openInNewTab
            >
              {chunks}
            </Link>
          ),
        })}
      </div>
      {/* TODO }
        <span>{weeeTakeBackAddition}</span>
      { */}
    </div>
  );
};
